// extracted by mini-css-extract-plugin
export default {"whatIs":"WhatIs_whatIs__3NiB5","blocks":"WhatIs_blocks__zMTCi"};